module.exports = __webpack_public_path__ + "static/icons/icon-tide-star-db10b162699ebcc927b7f9b66482c124.svg";